module.exports = __webpack_public_path__ + "img/advanced_analytics1.2c9041c4.png";